"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteTracker = exports.createTracker = exports.getTrackerName = void 0;
var loader_1 = require("./loader");
var trackerName = 'ab';
function getTrackerName() {
    return trackerName;
}
exports.getTrackerName = getTrackerName;
function createTracker(_a) {
    var platform = _a.platform, type = _a.type, appId = _a.appId, userId = _a.userId;
    if (typeof window.sp === 'undefined') {
        loader_1.loadScript();
    }
    trackerName = "ab-" + appId;
    window.sp(function onLoad() {
        if (Object.prototype.hasOwnProperty.call(this, trackerName)) {
            throw new Error("\u041C\u0435\u0442\u0440\u0438\u043A\u0430 \u0441 \u0438\u043C\u0435\u043D\u0435\u043C " + trackerName + " \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442");
        }
    });
    window.sp('newTracker', trackerName, "click.alfabank.ru/metrica/" + type, {
        appId: appId,
        platform: platform,
        discoverRootDomain: true,
        pageUnloadTimer: 50,
        forceSecureTracker: true,
    });
    if (userId) {
        window.sp('setUserId', userId);
        window.sp('trackPageView');
    }
}
exports.createTracker = createTracker;
function deleteTracker() {
    if (window.sp) {
        window.sp(function onLoad() {
            delete this[trackerName];
        });
    }
}
exports.deleteTracker = deleteTracker;

//# sourceMappingURL=tracker.js.map
